// extracted by mini-css-extract-plugin
module.exports = {"button-style":"ButtonOutline_button-style__Y1IE_"};